import { ChosenAttributes } from "../Basket/IBasket"
import { JsonProduct } from "./JsonProduct";

export interface JsonBasketRow {
    product:JsonProduct
    productChosenAttributes?:ChosenAttributes
    quantity:number
    discountByCouponCodeInRub:{[code:string]:number}
    lineDiscountKopecksByCouponCode?:{[code:string]:number}
    unitFinalPriceKopecks?:number[]
}

export function getMaxProductQuantity(p:{product:JsonProduct, chosenAttributes?:ChosenAttributes}){
    // console.log('getMaxProductQuantity', p.product, p.chosenAttributes)
    if(p.chosenAttributes && p.product.quantityBySize && Object.keys(p.product.quantityBySize).length>0){
        for(const attributeName of Object.keys(p.chosenAttributes)){
            if(attributeName.toLocaleLowerCase() === 'размер'){
                const size = p.chosenAttributes[attributeName].toString()
                // console.log('size=', size)

                const result = p.product.quantityBySize[size]
                // console.log('result=', result)
                return result || 0
                // if(result && result>0) return result
                // TODO: 0 can be returned here
            }
        }
    }
    return p.product.quantity
}
